/**
 * Check uf storage access is possible.
 */
export const testLocalStorage = () => {
    var test = 'gcp_local_storage_test';

    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch(e) {
        return false;
    }

}

export const updateLocalStorage = (field, value) => {

  if (testLocalStorage() === false ) {
    return false;
  }

  const newData = JSON.parse(localStorage.getItem("gcp_form_data"));

  newData[field] = value;

  localStorage.setItem("gcp_form_data", JSON.stringify(newData));
  
}

export const getDefaultFromLocalStorage = (field, backup) => {

  if (testLocalStorage() === false ) {
    return false;
  }

  const data = localStorage.getItem("gcp_form_data") != null ?
    JSON.parse(localStorage.getItem("gcp_form_data")) :
    {};

  const defaultValue = typeof(data[field]) != 'undefined' ?
    data[field] :
    backup;

  return defaultValue;
}
